






























































import Component from 'vue-class-component';
import FeedbackComponent from '@/components/base/FeedbackComponent';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { Getter, Mutation } from 'vuex-class';
import { FORM101_DATA, FORM101_META_DATA, FORM_READ_ONLY_MODE, SET_FORM101_DATA } from '@/types/form.types';
import { Form101DataModel } from '@/models/form/Form101Data.model';
import { Form101MetaData } from '@/models/form/Form101MetaData.model';

@Component({})
export default class ExtraInfoDetails extends FeedbackComponent {

  @Mutation(SET_FORM101_DATA, StoreNamespace.FORM) public setForm101Data;

  @Getter(FORM101_DATA, StoreNamespace.FORM) public form101Data!: Form101DataModel;
  @Getter(FORM101_META_DATA, StoreNamespace.FORM) public form101MetaData!: Form101MetaData;
  @Getter(FORM_READ_ONLY_MODE, StoreNamespace.FORM) public formReadOnlyMode!: boolean;

  public updateForm101Data(newVal: any, property: string) {
    this.setForm101Data({ ...this.form101Data, [property]: newVal });
  }
}
